import { render, staticRenderFns } from "./BankColumnsConfiguratorTab.vue?vue&type=template&id=2f7a1b31&scoped=true&"
import script from "./BankColumnsConfiguratorTab.vue?vue&type=script&lang=js&"
export * from "./BankColumnsConfiguratorTab.vue?vue&type=script&lang=js&"
import style0 from "./BankColumnsConfiguratorTab.vue?vue&type=style&index=0&id=2f7a1b31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a1b31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VIcon,VList,VListItem,VSubheader})
